module.exports = {
    marginTop: '0px !important',
    marginLeft: 'auto',
    marginRight: 'auto'
}


// WEBPACK FOOTER //
// ./src/utils/fixModalStyle.js